export default "__VITE_ASSET__CmIcsHhC__"